var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"competition_home"},[_c('competitionBanner'),_c('div',{ref:"homeContentBox",staticClass:"home_content",style:({
      background: ("url(" + _vm.bgImg + ") no-repeat"),
      paddingBottom: 200 + "px",
    })},[_c('competitionCalendar'),_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index},[(item.calendar.length > 0 || item.matchInfo.length > 0)?_c('homeZone',{attrs:{"dataObj":item}}):_vm._e()],1)})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }